import React from "react";
import SEO from "../../../components/SEO";

export default function PrivacyPolicy() {
 
  return (
    <>
     <SEO
      title="Politique de confidentialité | einsured.ca Canada"
      description="Découvrez la politique de confidentialité d’einsured.ca et comment vos données personnelles sont collectées, utilisées, protégées et conservées."
    />
    <div className="bg-white text-[#111827]">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 md:px-20 pt-14 sm:pt-16 pb-16 sm:pb-20">
        {/* MAIN HEADING */}
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-center mb-8 sm:mb-12 text-[#49628b]">
          Politique de confidentialité d'einsured.ca
        </h1>

        <div className="space-y-6 text-sm sm:text-base leading-relaxed">
         <h2 className="text-lg sm:text-xl font-bold text-[#111827] mb-4">
  Bienvenue sur einsured.ca.
</h2>

<div className="space-y-4 text-[#111827]">
  <p>einsured.ca est détenu et exploité par einsured.ca Inc.</p>

  <p>
    einsured.ca accorde une grande importance à votre vie privée et à la
    protection de vos données personnelles. Cette politique de
    confidentialité décrit les informations que nous collectons auprès de
    vous, la manière dont nous les collectons, comment nous les utilisons,
    comment nous obtenons votre consentement, combien de temps nous les
    conservons dans nos bases de données et, si nécessaire, avec qui nous
    les partageons.
  </p>

  <p>
    En utilisant le site Web et les services, vous acceptez les pratiques
    décrites dans cette politique de confidentialité. L'utilisation du site
    Web et des services est également soumise à nos conditions générales
    d'utilisation.
  </p>

  <p>
    Cette politique de confidentialité peut changer de temps à autre. Votre
    utilisation continue du site Web et des services après que nous ayons
    effectué des modifications est considérée comme une acceptation de ces
    modifications. Veuillez donc consulter régulièrement la politique pour
    prendre connaissance des mises à jour. Cette politique de
    confidentialité a été élaborée et est maintenue conformément à toutes
    les lois et réglementations fédérales et internationales applicables, et
    plus particulièrement avec la Loi sur la protection des renseignements
    personnels et les documents électroniques (LPRPDE – réglementation
    canadienne).
  </p>
</div>


          {/* 1. GENERAL INFORMATION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            1. INFORMATIONS GÉNÉRALES
          </h2>
          <p>
            Les données personnelles des utilisateurs collectées et traitées
            via le site Web :{" "}
            <a
              href="https://einsured.fresho.ca/"
              className="text-sky-600 underline"
            >
              https://einsured.fresho.ca/
            </a>{" "}
            (ci-après dénommé einsured.ca) seront sous la responsabilité et
            la charge de : einsured.ca Inc. Aman Ahuja, eadmin@einsured.ca,
            (844) 440-01284
          </p>

          {/* 2. TYPES OF INFORMATION GATHERED */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            2. TYPES D'INFORMATIONS COLLECTÉES
          </h2>
          <p>
            Les informations que nous obtenons des clients nous aident à
            personnaliser et à améliorer continuellement votre expérience sur
            einsured.ca. Voici les types d'informations que nous collectons :
            Informations que vous nous fournissez. Vous fournissez des
            informations lorsque vous recherchez, lisez et consultez du contenu
            sur notre site Web, planifiez une réunion, demandez un devis,
            contractez nos services, fournissez des informations via nos
            services et/ou communiquez avec nous via nos coordonnées ou nos
            formulaires de contact. En conséquence de ces actions, vous pourriez
            nous fournir les informations suivantes : Prénom et nom de famille
            Date de naissance Lieu de naissance Genre Adresse e-mail Numéro de
            téléphone (y compris le numéro WhatsApp) Adresse Province
            Informations de santé Toute information supplémentaire vous
            concernant que vous nous fournissez directement ou indirectement via
            notre site Web ou notre présence en ligne telle que les « cookies ».
            einsured.ca ne collectera aucune information personnellement
            identifiable vous concernant, sauf si vous la fournissez.
            Informations sensibles (informations de santé) : Les informations
            sensibles sont liées à la santé d'une personne. Certaines
            informations sensibles sur les utilisateurs sont nécessaires pour la
            bonne prestation de nos services. Les informations sensibles
            collectées via notre site Web et nos services ne seront utilisées et
            divulguées qu'aux fins pour lesquelles elles ont été fournies et
            autorisées, sauf si vous acceptez autrement ou si la loi permet
            l'utilisation ou la divulgation de ces informations. En utilisant le
            site Web et nos services, vous consentez et acceptez l'utilisation
            et le traitement de ces informations sensibles aux fins
            expressément décrites dans cette politique et pour la bonne
            prestation de nos services. Les informations sensibles fournies par
            les utilisateurs via l'utilisation du site Web et de nos services
            seront traitées et considérées comme des informations confidentielles
            et ne seront pas divulguées à des tiers non autorisés. Informations
            collectées automatiquement : En accédant et en utilisant le site Web,
            vous nous fournissez automatiquement les informations suivantes :
            L'appareil et les informations d'utilisation que vous utilisez pour
            accéder au site Web Votre adresse IP Caractéristiques du navigateur
            et de l'appareil Système d'exploitation URL de référence Votre
            localisation Quelles parties du site Web vous utilisez et à quelle
            fréquence Si vous accédez au site Web via un téléphone mobile, nous
            collecterons les informations suivantes : Identifiant de l'appareil
            mobile Modèle et fabricant Système d'exploitation Informations de
            version Adresse IP Google Analytics. Nous utilisons Google Analytics
            fourni par Google, Inc., USA (« Google »). Ces outils et
            technologies collectent et analysent certains types d'informations,
            notamment les adresses IP, les identifiants d'appareils et de
            logiciels, les URL de référence et de sortie, les mesures et
            statistiques d'utilisation des fonctionnalités, l'historique
            d'utilisation, l'adresse de contrôle d'accès au média (adresse MAC),
            les identifiants uniques d'appareils mobiles et d'autres informations
            similaires via l'utilisation de cookies. Les informations générées
            par Google Analytics (y compris votre adresse IP) peuvent être
            transmises et stockées par Google sur des serveurs aux États-Unis.
            Nous utilisons la collecte de données GOOGLE Analytics pour améliorer
            le site Web et notre service. Veuillez consulter la politique de
            confidentialité de Google ici :{" "}
            <a
              href="https://policies.google.com/privacy"
              className="text-sky-600 underline"
            >
              https://policies.google.com/privacy
            </a>
          </p>

          <p>
            Facebook Pixel : Notre site Web utilise le Facebook Pixel. Via le
            Facebook Pixel, nous pouvons collecter des informations sur les
            utilisateurs à différentes fins. Nous utilisons le Facebook Pixel
            aux fins suivantes : Collecter des statistiques sur notre plateforme
            (par exemple, le nombre d'utilisateurs ayant visité une page).
            Collecter des informations sur la façon dont vous interagissez avec
            notre plateforme (par exemple, si vous avez ouvert ou suivi des
            liens qu'elle contient). Personnaliser les services en ligne et les
            communications marketing. Adapter les publicités aux utilisateurs et
            optimiser les campagnes publicitaires. Les informations collectées
            via le Facebook Pixel seront collectées et stockées par Facebook et
            traitées conformément à sa politique de confidentialité. Les
            informations que nous collectons via le Facebook Pixel n'identifient
            pas personnellement l'utilisateur et ne seront jamais utilisées à
            d'autres fins que celles contenues dans cette politique de
            confidentialité et la politique de confidentialité de Facebook.
            Veuillez consulter la politique de confidentialité de Facebook
            ici :{" "}
            <a
              href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
              className="text-sky-600 underline"
            >
              https://www.facebook.com/privacy/explanation
            </a>{" "}
            Réseaux sociaux : Sur notre site Web, vous trouverez des liens et
            des fonctions liés à différents réseaux sociaux, où vous pouvez
            partager vos informations. Il est conseillé de consulter la politique
            de confidentialité et la protection des données de chaque réseau
            social utilisé sur notre site Web. Facebook :{" "}
            <a
              href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
              className="text-sky-600 underline"
            >
              https://www.facebook.com/privacy/explanation
            </a>{" "}
            LinkedIn :{" "}
            <a
              href="https://www.linkedin.com/legal/privacy-policy"
              className="text-sky-600 underline"
            >
              https://www.linkedin.com/legal/privacy-policy
            </a>{" "}
            Instagram :{" "}
            <a
              href="https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect"
              className="text-sky-600 underline"
            >
              http://instagram.com/about/legal/privacy/
            </a>
          </p>

          {/* 3. HOW LONG WE KEEP YOUR DATA */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            3. DURÉE DE CONSERVATION DE VOS DONNÉES
          </h2>
          <p>
            Les données personnelles fournies par les utilisateurs via le site
            Web et les services seront conservées pendant le temps nécessaire à
            la prestation des services. einsured.ca peut être autorisé à
            conserver les données personnelles pendant une période plus longue
            lorsque l'utilisateur a donné son consentement à ce traitement, tant
            que ce consentement n'est pas retiré. De plus, einsured.ca peut être
            obligé de conserver les données personnelles pendant une période plus
            longue lorsque cela est requis pour l'exécution d'une obligation
            légale ou sur ordonnance d'une autorité. Une fois la période de
            conservation expirée, les données personnelles seront supprimées. Par
            conséquent, le droit d'accès, le droit à l'effacement, le droit à la
            rectification et le droit à la portabilité des données ne peuvent
            plus être exercés après l'expiration de la période de conservation.
          </p>

          {/* 4. HOW WE USE YOUR INFORMATION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            4. COMMENT NOUS UTILISONS VOS INFORMATIONS
          </h2>
          <p>
            En général, nous utilisons les informations que nous collectons
            principalement pour fournir, maintenir, protéger et améliorer notre
            site Web et nos services actuels. Nous utilisons les informations
            personnelles collectées via notre site comme décrit ci-dessous et
            ailleurs dans cette politique pour : Vous identifier en tant
            qu'utilisateur dans notre système. Planifier des réunions. Fournir
            des devis. Fournir les services. Améliorer nos services, notre site
            Web et la façon dont nous exploitons notre entreprise. Comprendre et
            améliorer votre expérience d'utilisation de notre site Web et de nos
            services. Répondre à vos commentaires ou questions via notre équipe
            d'assistance. Vous envoyer des informations connexes, notamment des
            confirmations, des factures, des avis techniques, des mises à jour,
            des alertes de sécurité et des messages d'assistance et
            d'administration. Communiquer avec vous au sujet des événements à
            venir, des offres et des nouvelles concernant les services offerts
            par einsured.ca et nos partenaires sélectionnés. Objectifs marketing
            d'einsured.ca. Relier ou combiner vos informations avec d'autres
            informations que nous obtenons de tiers pour mieux comprendre vos
            besoins et vous fournir un meilleur service. Protéger, enquêter et
            dissuader les activités frauduleuses, non autorisées ou illégales.
          </p>

          {/* 5. HOW DO YOU GET MY CONSENT? */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            5. COMMENT OBTENEZ-VOUS MON CONSENTEMENT ?
          </h2>
          <p>
            En planifiant une réunion, en demandant un devis, en contractant nos
            services, en nous contactant via nos formulaires de contact ou nos
            coordonnées et en nous fournissant des informations personnelles pour
            communiquer avec vous, vous consentez à notre collecte, stockage et
            utilisation de vos informations selon les conditions contenues dans
            cette politique de confidentialité. Vous consentez à l'utilisation
            de cookies sur notre site Web lorsque vous donnez votre acceptation
            via la fenêtre pop-up affichée sur la page d'accueil lorsque vous
            entrez sur le site Web. Vous pouvez retirer votre consentement en
            nous envoyant votre demande via la page de contact ou en nous
            envoyant un e-mail à eadmin@einsured.ca
          </p>

          {/* 6. HOW WE SHARE INFORMATION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            6. COMMENT NOUS PARTAGEONS LES INFORMATIONS
          </h2>
          <p>
            Les informations personnelles de nos clients et utilisateurs
            constituent une partie importante et fondamentale de notre activité.
            En aucun cas nous ne vendrons ni ne partagerons des informations
            avec des tiers qui n'ont pas été préalablement autorisées par
            l'utilisateur, le client ou le propriétaire des données personnelles.
            Nous partageons les informations des utilisateurs et des clients
            uniquement et exclusivement comme décrit ci-dessous. Fournisseurs de
            services tiers. Nous utilisons des services tiers pour effectuer des
            fonctions sur notre site Web. Les exemples comprennent : la création
            et l'hébergement du site Web, l'envoi d'e-mails, la planification de
            réunions (SimplyBook.me), l'analyse de données (Google Analytics), la
            création de publicités (Facebook, Google), la fourniture d'une
            assistance marketing et la fourniture de résultats de recherche. Ces
            services et outils tiers peuvent avoir accès aux informations
            personnelles nécessaires pour accomplir leurs fonctions, mais ne
            peuvent pas utiliser ces informations à d'autres fins. Les
            informations partagées avec ces services tiers seront traitées et
            stockées conformément à leurs politiques de confidentialité
            respectives et à notre politique de confidentialité. Veuillez vous
            référer à la politique de confidentialité de ces services tiers.
            Transferts commerciaux. Dans l'éventualité où einsured.ca crée,
            fusionne avec ou est acquis par une autre entité ou société, vos
            informations seront probablement transférées. einsured.ca vous
            enverra un e-mail ou publiera un avis bien visible sur notre
            plateforme avant que vos informations ne soient soumises à une autre
            politique de confidentialité et le transfert et la gestion de vos
            informations privées seront conformes à toutes les exigences
            applicables. Protection d'einsured.ca et des autres. Nous divulguons
            des informations personnelles lorsque nous estimons que la
            divulgation est appropriée pour se conformer à la loi, faire
            respecter ou appliquer nos conditions générales et autres accords, ou
            protéger les droits, les biens ou la sécurité d'einsured.ca, de nos
            utilisateurs ou d'autres. Cela inclut l'échange d'informations avec
            d'autres entreprises et organisations pour la protection contre la
            fraude et la réduction des risques de crédit. Avec votre
            consentement. Hormis ce qui est stipulé ci-dessus, vous recevrez
            une notification lorsque des informations personnellement
            identifiables vous concernant pourraient être transmises à des tiers,
            et vous aurez la possibilité de choisir de ne pas partager ces
            informations. Informations anonymes. einsured.ca utilise les
            informations de navigation anonymes collectées automatiquement par
            nos serveurs principalement pour nous aider à administrer et à
            améliorer le site Web. Nous pouvons également utiliser des
            informations anonymes agrégées pour fournir des informations sur le
            site Web à des partenaires commerciaux potentiels et à d'autres
            entités non affiliées. Ces informations ne sont pas personnellement
            identifiables. Adresse e-mail. L'adresse e-mail que vous nous
            fournissez aux fins de recevoir nos communications par e-mail ne sera
            jamais louée ni vendue à un tiers.
          </p>

          {/* 7. PROTECTING YOUR INFORMATION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            7. PROTECTION DE VOS INFORMATIONS
          </h2>
          <p>
            Nous travaillons à protéger la sécurité de vos informations lors de
            la transmission en utilisant le logiciel Secure Sockets Layer (SSL),
            qui chiffre les informations que vous fournissez via le site Web. Si
            des transactions sont traitées sur le site Web, les informations de
            transaction sont transmises depuis et vers le site Web sous forme
            chiffrée en utilisant des connexions SSL standard de l'industrie pour
            aider à protéger ces informations contre l'interception. Nous
            limitons l'accès autorisé à vos informations personnelles aux
            personnes qui ont un motif légitime de connaître ces informations et
            aux personnes que vous avez autorisées à y accéder. einsured.ca suit
            les normes industrielles généralement acceptées pour protéger les
            informations personnelles qui nous sont soumises, tant pendant la
            transmission qu'une fois qu'einsured.ca les a reçues. Aucune méthode
            de transmission sur Internet, ni aucune méthode de stockage
            électronique, n'est sécurisée à 100 %. Par conséquent, bien
            qu'einsured.ca s'efforce d'utiliser des moyens commercialement
            acceptables pour protéger vos informations personnelles, nous ne
            pouvons pas garantir leur sécurité absolue. Nous ne vendrons,
            distribuerons ni ne louerons vos informations personnelles à des
            tiers sauf si nous avons votre permission ou si la loi l'exige.
          </p>

          {/* 8. RIGHTS */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            8. DROITS
          </h2>
          <p>
            Les utilisateurs qui fournissent des informations via notre site Web,
            en tant que personnes concernées et propriétaires de données, ont le
            droit d'accéder, de rectifier, de télécharger ou de supprimer leurs
            informations, ainsi que de restreindre et de s'opposer à certains
            traitements de leurs informations. Bien que certains de ces droits
            s'appliquent de manière générale, d'autres ne s'appliquent que dans
            certaines circonstances limitées. Nous décrivons ces droits
            ci-dessous : Accès et portabilité : pour accéder et savoir quelles
            informations sont stockées sur nos serveurs, vous pouvez nous envoyer
            votre demande via nos coordonnées. Rectifier, restreindre, limiter
            et/ou supprimer : Vous pouvez également rectifier, restreindre,
            limiter ou supprimer une grande partie de vos informations. Droit
            d'être informé : Les utilisateurs de notre site Web seront informés,
            sur demande, des données que nous collectons, de la façon dont elles
            sont utilisées, de la durée de leur conservation et si elles sont
            partagées avec des tiers. Objection : Lorsque nous traitons vos
            informations sur la base de nos intérêts légitimes, comme expliqué
            ci-dessus, ou dans l'intérêt public, vous pouvez vous opposer à ce
            traitement dans certaines circonstances. Dans de tels cas, nous
            cesserons de traiter vos informations sauf si nous avons des raisons
            légitimes impérieuses de continuer à les traiter ou lorsque cela est
            nécessaire pour des raisons juridiques. Retrait du consentement :
            Lorsque vous avez préalablement donné votre consentement, par exemple
            pour nous permettre de traiter et de stocker vos informations
            personnelles, vous avez le droit de retirer votre consentement au
            traitement et au stockage de vos informations à tout moment. Par
            exemple, vous pouvez retirer votre consentement en mettant à jour vos
            paramètres. Dans certains cas, nous pouvons continuer à traiter vos
            informations après que vous ayez retiré votre consentement si nous
            avons une base légale pour le faire ou si votre retrait de
            consentement était limité à certaines activités de traitement.
            Plainte : Si vous souhaitez déposer une plainte concernant notre
            utilisation de vos informations (et sans préjudice de tout autre
            droit que vous pourriez avoir), vous avez le droit de le faire auprès
            de votre autorité de contrôle locale. Les utilisateurs peuvent
            exercer tous ces droits en nous contactant via les coordonnées ou la
            page de contact. Droits liés à la prise de décision automatisée, y
            compris le profilage : les utilisateurs du site Web peuvent demander
            que nous leur fournissions une copie des activités de traitement
            automatisé que nous effectuons s'ils pensent que des données sont
            traitées illégalement. Les utilisateurs peuvent exercer leurs droits
            relatifs aux données personnelles qu'ils fournissent à einsured.ca, à
            tout moment, en nous envoyant leur demande via nos coordonnées et nous
            traiterons et répondrons à leur demande dans les plus brefs délais.
          </p>

          {/* 9. CHILDREN'S ONLINE PRIVACY PROTECTION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            9. PROTECTION DE LA VIE PRIVÉE DES ENFANTS EN LIGNE
          </h2>
          <p>
            Nous sommes en conformité avec les exigences de la Loi sur la
            protection des renseignements personnels et les documents
            électroniques (LPRPDE – réglementation canadienne), concernant la
            protection des données personnelles des mineurs. Nous ne collectons
            aucune information auprès de quiconque ayant moins de 13 ans, sauf
            si cela est fourni par les parents ou les tuteurs dans le but de
            prendre une assurance ou un plan d'épargne pour leurs enfants. Notre
            site Web et nos services sont tous destinés aux personnes âgées d'au
            moins 13 ans. Si vous apprenez que votre enfant nous a fourni des
            informations personnelles, veuillez nous contacter. Si nous apprenons
            qu'un enfant nous a fourni des informations personnelles, nous prendrons
            des mesures pour supprimer ces informations.
          </p>

          {/* 10. EDITING AND DELETING INFORMATION */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            10. MODIFICATION ET SUPPRESSION DES INFORMATIONS
          </h2>
          <p>
            Si vous estimez que les informations que nous détenons sur vous sont
            incorrectes ou incomplètes, veuillez nous écrire ou nous envoyer un
            e-mail dès que possible. Nous corrigerons rapidement toute
            information avérée incorrecte. Vous pouvez modifier, rectifier et
            supprimer vos informations à tout moment, veuillez nous contacter
            via nos coordonnées. Pour vous désabonner des e-mails d'einsured.ca,
            suivez les instructions incluses dans l'e-mail. Votre demande devrait
            être traitée dans les 48 heures.
          </p>

          {/* 11. THIRD PARTIES */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            11. TIERS
          </h2>
          <p>
            Sauf indication contraire expressément mentionnée dans cette
            politique de confidentialité, ce document traite uniquement de
            l'utilisation et de la divulgation des informations qu'einsured.ca
            collecte auprès de vous. Si vous divulguez vos informations à
            d'autres personnes, qu'il s'agisse d'autres utilisateurs ou de
            fournisseurs sur einsured.ca, des règles différentes peuvent
            s'appliquer à leur utilisation ou à la divulgation des informations
            que vous leur divulguez. einsured.ca ne contrôle pas les politiques
            de confidentialité des tiers, et vous êtes soumis aux politiques de
            confidentialité de ces tiers le cas échéant. einsured.ca n'est pas
            responsable des pratiques de confidentialité ou de sécurité des
            autres sites Web sur Internet, même ceux liés au site Web ou depuis
            celui-ci. einsured.ca vous encourage à poser des questions avant de
            divulguer vos informations personnelles à d'autres.
          </p>

          {/* 12. CONTACT US */}
          <h2 className="text-lg sm:text-xl font-bold text-[#111827]">
            12. CONTACTEZ-NOUS
          </h2>
          <p>
            Si vous avez des questions ou des préoccupations concernant cette
            politique de confidentialité et la gestion et la sécurité de vos
            données, veuillez nous contacter via notre page de contact ou via les
            coordonnées ci-dessous : einsured.ca Inc. Aman Ahuja,
            eadmin@einsured.ca, (844) 440-0128
          </p>
        </div>
      </section>
    </div>
    </>
  );
}
